/* eslint-disable no-param-reassign */
import React, { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';

import classes from './styles.module.scss';

const ResizableTextarea = (props) => {
    const { defaultValue, disabled, minRows, maxRows, onChange, placeholder, value, className, ...restProps } = props;

    const inputProps = {
        placeholder,
        disabled,
        value,
    };

    if (defaultValue) {
        inputProps.defaultValue = defaultValue;
    }

    const [rows, setRows] = useState(minRows);

    const textareaRef = useRef(null);
    const textareaPaddingYRef = useRef(null);
    const textareaLineHeightRef = useRef(null);

    useEffect(() => {
        if (!value) {
            setRows(minRows);
        }
    }, [minRows, value]);

    useEffect(() => {
        const { paddingTop, paddingBottom, lineHeight } = window.getComputedStyle(textareaRef.current);
        textareaPaddingYRef.current = parseFloat(paddingTop) + parseFloat(paddingBottom);
        textareaLineHeightRef.current = parseFloat(lineHeight);
    }, []);

    const handleChange = (event) => {
        const currentRows = (event.target.scrollHeight - textareaPaddingYRef.current) / textareaLineHeightRef.current;
        if (currentRows >= maxRows) {
            event.target.scrollTop = event.target.scrollHeight;
        }
        setRows(Math.min(currentRows, maxRows));
        onChange(event);
    };

    return (
        <textarea
            ref={textareaRef}
            rows={rows}
            className={clsx(classes.input, className)}
            onChange={handleChange}
            {...inputProps}
            {...restProps}
        />
    );
};

ResizableTextarea.defaultProps = {
    className: undefined,
    defaultValue: undefined,
    disabled: false,
    placeholder: '',
    minRows: 1,
    maxRows: 1,
};

ResizableTextarea.propTypes = {
    className: PropTypes.string,
    defaultValue: PropTypes.string,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string.isRequired,
    minRows: PropTypes.number,
    maxRows: PropTypes.number,
};

export default ResizableTextarea;
